import React, { createContext, useCallback, useMemo } from "react";
import { useState, useEffect } from "react";
// import { GetAllCarsList, GetLinkListedCars } from "../Api/PortalApis";
import {
  maxPrice,
  minPrice,
  minKms,
  maxKms,
  minYear,
  maxYear,
  minOwners,
  maxOwners,
} from "./constants";

const initialState = {
  totalCars: 0,
  setTotalCars: () => {},
  userIp: "",
  setUserIp: () => {},
  allCarsList: [],
  setAllCarsList: () => {},
  currentPageCarList: [],
  searchPageNo: 1,
  setSearchPageNo: () => {},
  itemsPerPage: 6,

  // filters
  selectedYearList: [],
  setSelectedYearList: () => {},
  selectedTransmissionList: [],
  setSelectedTransmissionList: () => {},
  selectedFuelList: [],
  setSelectedFualList: () => {},
  selectedColors: [],
  setSelectedColors: () => {},
  selectedCategories: [],
  setSelectedCategories: () => {},
  selectedCarMakes: [],
  setSelectedCarMakes: () => {},
  selectedCarModels: [],
  setSelectedCarModels: () => {},
  priceValues: [],
  setPriceValues: () => {},
  kmsValues: [],
  setKmsValues: () => {},
  noOwners: [],
  setNoOwners: () => {},

  allFilteredData: [],

  setNonCategoryListEmpty: () => {},
  setNonMakeFilterEmpty: () => {},

  linkId: "",
  setLinkId: () => {},

  setIsFromCarByModal: () => {},
  setAllFilteredData: () => {},

  isAllFilterEmpty: () => {},
  setHasSearchPageLoaded: () => {},
};

export const PortalContext = createContext(initialState);

const PortalContextProvider = (props) => {
  // states
  const [totalCars, setTotalCars] = useState(null);
  const [userIp, setUserIp] = useState("");
  const [allCarsList, setAllCarsList] = useState([]);
  const [currentPageCarList, setCurrentPageCarList] = useState([]);
  const [searchPageNo, setSearchPageNo] = useState(1);
  const [linkId, setLinkId] = useState([]);

  const [allCarsLoading, setAllCarsLoading] = useState([]);

  const [selectedYearList, setSelectedYearList] = useState([]);
  const [selectedTransmissionList, setSelectedTransmissionList] = useState([]);
  const [selectedFuelList, setSelectedFualList] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCarMakes, setSelectedCarMakes] = useState([]);
  const [selectedCarModels, setSelectedCarModels] = useState([]);

  const [isFromCarByModal, setIsFromCarByModal] = useState(false);

  const [allFilteredData, setAllFilteredData] = useState([]);

  const [yearFilteredData, setYearFilteredData] = useState([]);
  const [transmissionFilteredData, setTransmissionFilteredData] = useState([]);
  const [fualFilteredData, setFualFilteredData] = useState([]);
  const [colorFilteredData, setColorFilteredData] = useState([]);
  const [categoryFilteredData, setCategoryFilteredData] = useState([]);
  const [carMakerFilteredData, setCarMakerFilteredData] = useState([]);
  const [carModelFilteredData, setCarModelFilteredData] = useState([]);
  const [priceFilteredData, setPriceFilteredData] = useState([]);
  const [kmsFilteredData, setKmsFilteredData] = useState([]);
  const [noOwnersFilteredData, setNoOwnersFilteredData] = useState([]);

  const [yearValues, setYearValues] = useState([0, 100]);
  const [priceValues, setPriceValues] = useState([0, 100]);
  const [kmsValues, setKmsValues] = useState([0, 100]);
  const [noOwners, setNoOwners] = useState([0, 100]);
  const [hasSearchPageLoaded, setHasSearchPageLoaded] = useState(false);

  /*Edit Report Data Start*/
  const [summaryData, setSummaryData] = useState({
    marketValue: "",
    overallRating: "",
    recommended: "",
  });
  const [inspectionSummary, setInspectionSummary] = useState("");
  const [lastSaved, setLastSaved] = useState("");
  const [challans, setChallans] = useState([]);
  const [initialChallans, setInitialChallans] = useState([]);
  const [errorCodes, setErrorCodes] = useState([]);
  const [keyInfo, setKeyInfo] = useState({});
  const [insuranceData, setInsuranceData] = useState({});
  const [dentsData, setDentsData] = useState({});
  const [tyreLifeData, setTyreLifeData] = useState({});
  const [majorRepairs, setMajorRepairs] = useState([]);
  const [minorRepairs, setMinorRepairs] = useState([]);
  const [ownerCount, setOwnerCount] = useState("");
  const [categoryRatings, setCategoryRatings] = useState({
    exterior_evaluation: 0,
    head_lights_and_indicators: 0,
    interior_evaluation: 0,
    infotainment_electrical_systems_accessories_analysis: 0,
    air_condition_system_check: 0,
    engine_health_and_diagnostics: 0,
    transmission_assessment: 0,
    battery_health_checkup: 0,
    suspension_brakes_and_battery: 0,
    tires_and_tools: 0,
  });
  const [categoryData, setCategoryData] = useState([]);
  const [reportViewData, setReportViewData] = useState({});
  const [inspectionData, setInspectionData] = useState({});

  const [vehiclesInfo, setVehiclesInfo] = useState({
    make: "",
    model: "",
    year: "",
    regNo: "",
    mfgDate: "",
    fuel: "",
    colour: "",
    regDate: "",
    engineCC: "",
    engineNumber: "",
    chassisNumber: "",
    transmission: ""
  });

  const updateSummaryData = (newSummaryData) => {
    console.log("Updating summary data:", newSummaryData);
    setSummaryData((prev) => ({
      ...prev,
      ...newSummaryData,
    }));
  };

  const updateInspectionSummary = (newSummary) => {
    if (typeof newSummary !== "string") {
      // Assuming newSummary should be a string, convert it properly
      newSummary = String(newSummary);
    }

    setInspectionSummary(newSummary);
    setLastSaved(new Date().toLocaleString());
  };

  const loadInitialChallans = useCallback(
    (apiChallans) => {
      if (!Array.isArray(apiChallans)) {
        console.error(
          "apiChallans is expected to be an array but received:",
          apiChallans
        );
        return;
      }
      const taggedChallans = apiChallans.map((challan) => ({
        ...challan,
        deletable: !initialChallans?.includes(challan),
      }));
      setChallans(taggedChallans);
    },
    [initialChallans]
  );

  console.log(initialChallans, "initialChallans");
  const addChallan = (challan) => {
    setChallans((prevChallans) => [...prevChallans, challan]);
  };

  const removeChallan = (index) => {
    setChallans((prevChallans) => prevChallans.filter((_, i) => i !== index));
  };

  const calculateTotalChallans = () => {
    let combinedChallans = [...initialChallans];

    // Add only new challans from `challans` that are not already included in `initialChallans`
    challans.forEach((challan) => {
      if (
        !combinedChallans.some(
          (c) =>
            c.challanDate === challan.challanDate && c.amount === challan.amount
        )
      ) {
        combinedChallans.push(challan);
      }
    });
    const unpaidChallans = combinedChallans.filter(
      (challan) => challan.challanStatus !== "Paid"
    );
    return unpaidChallans.reduce((total, challan) => {
      const amount = parseFloat(challan.amount.toString().replace(/Rs\. /, ""));
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);
  };

  const addErrorCode = (newCode) => {
    setErrorCodes((prevCodes) => [...prevCodes, newCode]);
  };

  // Function to update key information in a generalized way
  const updateKeyInfo = (newData) => {
    console.log("Updating key info with:", newData);
    setKeyInfo((prev) => ({ ...prev, ...newData }));
  };

  // Add or update insurance data
  const updateInsuranceData = (newData) => {
    console.log("Updating insurance data:", newData);
    setInsuranceData((prev) => ({ ...prev, ...newData }));
  };

  // Add a new repair
  const addRepair = (repair, type) => {
    if (type === "Major") {
      setMajorRepairs((prev) => [...prev, repair]);
    } else {
      setMinorRepairs((prev) => [...prev, repair]);
    }
  };

  // Remove a repair based on index
  const removeRepair = (index, type) => {
    if (type === "Major") {
      setMajorRepairs((prev) => prev.filter((_, i) => i !== index));
    } else {
      setMinorRepairs((prev) => prev.filter((_, i) => i !== index));
    }
  };

  // Update Tyre Life Data
  const updateTyreLifeData = (newData) => {
    setTyreLifeData(newData);
  };

  const updateCategoryRating = (category, score) => {
    setCategoryRatings((prev) => ({
      ...prev,
      [category]: Math.min(10, Math.max(0, parseInt(score, 10))),
    }));
  };

  function parseRangeAnswer(answer) {
    if (!answer) return 0;
    const lower = answer.toLowerCase();
    if (lower.includes("no dent") || lower.includes("no scratch")) return 0;
    if (answer.includes("-")) {
      const parts = answer.split("-");
      const num1 = parseFloat(parts[0]);
      const num2 = parseFloat(parts[1]);
      return (num1 + num2) / 2 || 0;
    } else if (answer.includes("+")) {
      const num = parseFloat(answer);
      return isNaN(num) ? 0 : num;
    } else {
      const num = parseFloat(answer);
      return isNaN(num) ? 0 : num;
    }
  }

  function evaluateExteriorCondition(exteriorData) {
    let totalDents = 0;
    let totalScratches = 0;

    exteriorData.forEach((item) => {
      const q = item.questions;
      if (
        q.sub_question &&
        q.sub_question.question_description.toLowerCase().includes("dent")
      ) {
        const selectedDent = q.sub_question.select_options?.choices
        ? Object.values(q.sub_question.select_options.choices).find(
            (choice) => choice.selected
          )
        : null;
        const dentValue = selectedDent
          ? parseRangeAnswer(selectedDent.choice)
          : 0;
        totalDents += dentValue;

        if (
          q.sub_question.sub_question &&
          q.sub_question.sub_question.question_description
            .toLowerCase()
            .includes("scratch")
        ) {
          const selectedScratch = q.sub_question.sub_question.select_options?.choices
          ? Object.values(q.sub_question.sub_question.select_options.choices).find(
              (choice) => choice.selected
            )
          : null;
          const scratchValue = selectedScratch
            ? parseRangeAnswer(selectedScratch.choice)
            : 0;
          totalScratches += scratchValue;
        }
      }
    });

    if (totalDents > 3) {
      return totalDents >= 7 ? "BAD" : "AVERAGE";
    } else {
      if (totalScratches >= 7) return "BAD";
      else if (totalScratches >= 4) return "AVERAGE";
      else return "GOOD";
    }
  }

  function evaluateInteriorCondition(interiorData) {
    let overall = "GOOD";
    interiorData.forEach((item) => {
      const q = item.questions;
      if (q.sub_question && q.sub_question.select_options?.choices) {
        const selected = Object.values(q.sub_question.select_options.choices).find(
          (choice) => choice.selected
        );
        if (selected) {
          const answer = selected.choice.toLowerCase();
          if (answer.includes("damaged")) {
            overall = "BAD";
          } else if (
            overall !== "BAD" &&
            (answer.includes("stained") || answer.includes("crack"))
          ) {
            overall = "AVERAGE";
          }
        }
      }
    });
    return overall;
  }

  function parseDentsAndScratches(exteriorData) {
    const result = {};
    exteriorData.forEach((item) => {
      const mainQ = item.questions;
      if (
        mainQ?.sub_question &&
        mainQ.sub_question.question_description.toLowerCase().includes("dent")
      ) {
        const dentSubQ = mainQ.sub_question;
        const scratchSubQ = dentSubQ.sub_question;
        const panelName = dentSubQ.question_description
          .replace(/number of dent on/i, "")
          .replace(/\?/g, "")
          .trim();
          const dentChoice = dentSubQ.select_options?.choices
          ? Object.values(dentSubQ.select_options.choices).find((c) => c.selected)
          : null;
        const dentLabel = dentChoice ? dentChoice.choice : "No Dents";
        let scratchLabel = "No Scratches";
        if (scratchSubQ) {
          const scratchChoice = scratchSubQ.select_options?.choices
          ? Object.values(scratchSubQ.select_options.choices).find(
              (c) => c.selected
            )
          : null;
          if (scratchChoice) {
            scratchLabel = scratchChoice.choice;
            if (scratchLabel.toLowerCase().includes("no scratch")) {
              scratchLabel = "No Scratches";
            }
          }
        }
        if (panelName) {
          result[panelName] = {
            Dents: dentLabel,
            Scratches: scratchLabel,
          };
        }
      }
    });
    return result;
  }

  function parseTyreLife(tyresData) {
    const result = {};
    console.log(tyresData, "tyresData");
    tyresData.forEach((item) => {
      const mainQ = item.questions;
      const subQ = mainQ.sub_question;
      if (
        subQ &&
        subQ.question_description.toLowerCase().includes("tyre life percentage")
      ) {
        const selected = subQ.select_options?.choices
        ? Object.values(subQ.select_options.choices).find((c) => c.selected)
        : null;
        if (selected) {
          const position = subQ.question_description
            .replace(/choose/i, "")
            .replace(/tyre life percentage\?/i, "")
            .replace(/\?/g, "")
            .trim();
          result[position] = selected.choice + "%";
        }
      }
    });
    const positions = Object.keys(result);
    if (positions.length) {
      let total = 0;
      positions.forEach((pos) => {
        const valStr = result[pos].replace("%", "");
        if (valStr.includes("-")) {
          // Handle range values like "0-20"
          const [min, max] = valStr.split("-").map(num => parseInt(num, 10));
          if (!isNaN(min) && !isNaN(max)) {
            // Calculate average for this position's range
            const positionAvg = (min + max) / 2;
            total += positionAvg;
          }
        } else {
          // Handle single values
          const valNum = parseInt(valStr, 10);
          if (!isNaN(valNum)) {
            total += valNum;
          }
        }
      });
      // Calculate final average by dividing total by number of positions
      const avg = Math.round(total / positions.length);
      result["Average"] = avg + "%";
    }
    return result;
  }

  const parsedCategoryData = useMemo(() => {
    if (!categoryData) return [];
    return typeof categoryData === "string"
      ? JSON.parse(categoryData)
      : categoryData;
  }, [categoryData]);

  // GENERAL INFORMATION from categoryData
  const generalInfoData = useMemo(() => {
    return (
      parsedCategoryData.find(
        (cat) =>
          cat.titile.trim().toLowerCase() === "general information" ||
          cat.titile.trim().toLowerCase() === "maklumat am" || cat.titile.trim().toLowerCase() === "ข้อมูลทั่วไป"
      )?.questionary || []
    );
  }, [parsedCategoryData]);

  const majorAccidentAnswer = useMemo(() => {
    console.log(generalInfoData, 'general info data')
    const q = generalInfoData.find((item) =>
      item.questions.question_description.toLowerCase().includes("accident") ||
    item.questions?.question_description?.toLowerCase().includes("kemalangan") || item.questions?.question_description?.toLowerCase().includes("อุบัติเหตุ")
    );
    if (
      q &&
      q.questions?.select_options
    ) {
      const selectedChoice = Object.values(q.questions.select_options.choices).find(
        (choice) => choice.selected
      );
      console.log(selectedChoice, 'choice testing')
      return selectedChoice ? (["Yes", "ya", "ใช่"].includes(selectedChoice.choice) ? "YES" : "NO") : "NO";
    }
    return "-";
  }, [generalInfoData]);

  const floodDamageAnswer = useMemo(() => {
    const q = generalInfoData.find((item) =>
      item.questions.question_description
        .toLowerCase()
        .includes("flood-damaged") ||
        item.questions?.question_description?.toLowerCase().includes("banjir") || item.questions?.question_description?.toLowerCase().includes("เสียหายจากน้ำท่วม")
    );
    if (
      q &&
      q.questions?.select_options
    ) {
      const selectedChoice = Object.values(q.questions.select_options.choices).find(
        (choice) => choice.selected
      );
      return selectedChoice ? (["Yes", "ya", "ใช่"].includes(selectedChoice.choice) ? "YES" : "NO") : "NO";
    }
    return "-";
  }, [generalInfoData]);
  
  console.log(floodDamageAnswer, 'flood testing', majorAccidentAnswer)

  const exteriorInspectionData = useMemo(() => {
    return (
      parsedCategoryData.find(
        (cat) => cat.titile.trim().toLowerCase() === "exterior inspection"
      )?.questionary || []
    );
  }, [parsedCategoryData]);

  const computedExteriorCondition = useMemo(() => {
    return evaluateExteriorCondition(exteriorInspectionData);
  }, [exteriorInspectionData]);

  const dentsAndScratchesMap = useMemo(() => {
    return parseDentsAndScratches(exteriorInspectionData);
  }, [exteriorInspectionData]);
  const hasDentDetails = Object.keys(dentsAndScratchesMap).length > 0;

  // INTERIOR INSPECTION
  const interiorInspectionData = useMemo(() => {
    return (
      parsedCategoryData.find(
        (cat) => cat.titile.trim().toLowerCase() === "interior inspection"
      )?.questionary || []
    );
  }, [parsedCategoryData]);

  const computedInteriorCondition = useMemo(() => {
    return evaluateInteriorCondition(interiorInspectionData);
  }, [interiorInspectionData]);

  // TIRES AND TOOLS INSPECTION: Parse tyre life details
  const tiresCategoryData = useMemo(() => {
    return (
      parsedCategoryData.find(
        (cat) =>
          cat.titile.trim().toLowerCase() === "tires and tools inspection"
      )?.questionary || []
    );
  }, [parsedCategoryData]);

  const parsedTyreLife = useMemo(() => {
    return parseTyreLife(tiresCategoryData);
  }, [tiresCategoryData]);
console.log(parsedTyreLife, 'parsed')
  const averageTyreLife = useMemo(() => {
    return parsedTyreLife["Average"] || "-";
  }, [parsedTyreLife]);

  const hasTyreLifeData = useMemo(() => {
    const keys = Object.keys(parsedTyreLife).filter((k) => k !== "Average");
    return keys.length > 0;
  }, [parsedTyreLife]);

  /*Edit Report Data End*/

  const priceDiff = maxPrice - minPrice;
  const kmsDiff = maxKms - minKms;
  const yearDiff = maxYear - minYear;
  const noOwnersDiff = maxOwners - minOwners;

  // console.log("linkid", linkId);

  function setNonCategoryListEmpty() {
    setSelectedYearList([]);
    setSelectedTransmissionList([]);
    setSelectedFualList([]);
    setSelectedColors([]);
    setSelectedCarMakes([]);
    setSelectedCarModels([]);

    setYearValues([0, 100]);
    setPriceValues([0, 100]);
    setKmsValues([0, 100]);
    setNoOwners([0, 100]);
  }

  function setNonMakeFilterEmpty() {
    setSelectedYearList([]);
    setSelectedTransmissionList([]);
    setSelectedFualList([]);
    setSelectedColors([]);
    setSelectedCarModels([]);
    setSelectedCategories([]);
    setYearValues([0, 100]);
    setPriceValues([0, 100]);
    setKmsValues([0, 100]);
    setNoOwners([0, 100]);
  }

  function getSliderValue(diff, per, minVal) {
    return Math.round(minVal + (per * diff) / 100);
  }

  const itemsPerPage = 6;

  function isAllFilterEmpty() {
    return (
      selectedYearList.length === 0 &&
      selectedTransmissionList.length === 0 &&
      selectedFuelList.length === 0 &&
      selectedColors.length === 0 &&
      selectedCategories.length === 0 &&
      selectedCarMakes.length === 0
    );
  }

  function isAllSliderFullRange() {
    return (
      (priceValues[0] === 0 && priceValues[1]) === 100 &&
      kmsValues[0] === 0 &&
      kmsValues[1] === 100 &&
      yearValues[0] === 0 &&
      yearValues[1] === 100 &&
      noOwners[0] === 0 &&
      noOwners[1] === 100
    );
  }

  function setFiltersFromSession() {
    const sessionFilters = JSON.parse(sessionStorage.getItem("filters"));
    if (!sessionFilters) return;
    // key labels to extract from session filters
    const keys = [
      "Category",
      "Car Make",
      "Car Model",
      "Year",
      "Transmission Type",
      "Fuel Type",
      "Price",
      "Kms",
      "No of owners",
      "Color",
    ];

    // take each key. check key is present, if present assingn the value to the corresponding filter
    if (sessionFilters["Category"]) {
      setSelectedCategories(sessionFilters["Category"]);
    }
    if (sessionFilters["Car Make"]) {
      setSelectedCarMakes(sessionFilters["Car Make"]);
    }
    if (sessionFilters["Car Model"]) {
      setSelectedCarModels(sessionFilters["Car Model"]);
    }
    if (sessionFilters["Year"]) {
      setYearValues(sessionFilters["Year"]);
    }
    if (sessionFilters["Transmission Type"]) {
      setSelectedTransmissionList(sessionFilters["Transmission Type"]);
    }
    if (sessionFilters["Fuel Type"]) {
      setSelectedFualList(sessionFilters["Fuel Type"]);
    }
    if (sessionFilters["Price"]) {
      setPriceValues(sessionFilters["Price"]);
    }
    if (sessionFilters["Kms"]) {
      setKmsValues(sessionFilters["Kms"]);
    }
    if (sessionFilters["No of owners"]) {
      setNoOwners(sessionFilters["No of owners"]);
    }
    if (sessionFilters["Color"]) {
      setSelectedColors(sessionFilters["Color"]);
    }

    // export this function run on the backbutton click of /car details to direct to /search-cars
  }

  // async function getAllCars() {
  //   try {
  //     // if (!linkId) {

  //     const resp = await GetAllCarsList(0);
  //     if (resp.status === 200) {
  //       setAllCarsList(resp.data);
  //       setAllFilteredData(resp.data);
  //     }
  //   } catch (error) {
  //     console.error("fetching all cars failed!", error);
  //   }
  // }

  // async function getLinkListedCars(linkId) {
  //   try {
  //     const resp = GetLinkListedCars(linkId);
  //     if (resp.status === 200) {
  //       console.log("link cars", resp);
  //     }
  //   } catch (error) {
  //     console.error("error getting link based car list", error);
  //   }
  // }

  function filterByValue(allData, yearList, param_name) {
    const updatedData = allData.filter((data) =>
      yearList.includes(data[param_name])
    );
    return updatedData;
  }

  function filterByRange(allData, rangeData, param_name, diff, minVal) {
    const lowerVal = getSliderValue(diff, rangeData[0], minVal);
    const upperVal = getSliderValue(diff, rangeData[1], minVal);

    const updatedData = allData.filter(
      (data) => data[param_name] >= lowerVal && data[param_name] <= upperVal
    );
    return updatedData;
  }

  const getCombinedFilterData = (...arrays) => {
    const commonObjects = [];
    const countMap = {};

    // console.log(...arrays);

    // Count occurrences of each vehicle ID in the arrays
    for (const array of arrays) {
      for (const obj of array) {
        const vid = obj.vehicleId;
        countMap[vid] = (countMap[vid] || 0) + 1;
      }
    }
    // console.log(countMap);

    // Find objects with vehicle IDs present in all arrays
    for (const array of arrays) {
      for (const obj of array) {
        const vid = obj.vehicleId;
        if (
          countMap[vid] === arrays.length &&
          !commonObjects.some((o) => o.vehicleId === vid)
        ) {
          commonObjects.push(obj);
        }
      }
    }

    return commonObjects;
  };

  // Solution try
  // useEffect(() => {
  //   const isFiltersNull = isAllFilterEmpty();
  //   const isAllRangeFull = isAllSliderFullRange();
  //   if (isFiltersNull && isAllRangeFull) {
  //     getAllCars();
  //     return;
  //   }

  //   const fualData = filterByValue(allCarsList, selectedFuelList, "fuel");
  //   setFualFilteredData(fualData);

  //   const transmissionData = filterByValue(
  //     allCarsList,
  //     selectedTransmissionList,
  //     "transmission"
  //   );
  //   setTransmissionFilteredData(transmissionData);

  //   const colorData = filterByValue(allCarsList, selectedColors, "color");
  //   setColorFilteredData(colorData);

  //   const categoryData = filterByValue(allCarsList, selectedCategories, "body");
  //   setCategoryFilteredData(categoryData);

  //   const makeData = filterByValue(allCarsList, selectedCarMakes, "make");
  //   setCarMakerFilteredData(makeData);

  //   const modelData = filterByValue(allCarsList, selectedCarModels, "model");
  //   setCarModelFilteredData(modelData);

  //   // when  range slider values is full then call all cars (has to be added along with checkign allfilterempty)
  //   const priceData = filterByRange(
  //     allCarsList,
  //     priceValues,
  //     "price",
  //     priceDiff,
  //     minPrice
  //   );
  //   setPriceFilteredData(priceData);

  //   const kmsData = filterByRange(
  //     allCarsList,
  //     kmsValues,
  //     "odometer",
  //     kmsDiff,
  //     minKms
  //   );
  //   setKmsFilteredData(kmsData);

  //   const yearData = filterByRange(
  //     allCarsList,
  //     yearValues,
  //     "manuyear",
  //     yearDiff,
  //     minYear
  //   );
  //   setYearFilteredData(yearData);

  //   const ownerData = filterByRange(
  //     allCarsList,
  //     noOwners,
  //     "owner",
  //     noOwnersDiff,
  //     minOwners
  //   );
  //   setNoOwnersFilteredData(ownerData);
  // }, [
  //   selectedFuelList,
  //   selectedTransmissionList,
  //   selectedColors,
  //   selectedCategories,
  //   selectedCarMakes,
  //   selectedCarModels,
  //   priceValues,
  //   kmsValues,
  //   yearValues,
  //   noOwners,
  //   allCarsList,
  //   filterByRange,
  //   isAllFilterEmpty,
  //   isAllSliderFullRange,
  //   kmsDiff,
  //   noOwnersDiff,
  //   priceDiff,
  //   yearDiff,
  // ]);

  // individual function calls
  // useEffect(() => {
  //   const newData = filterByValue(allCarsList, selectedFuelList, "fuel");
  //   const isFiltersNull = isAllFilterEmpty();
  //   if (isFiltersNull) {
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     // FILTERED DATA TEMP
  //     setFualFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [selectedFuelList]);

  // useEffect(() => {
  //   const newData = filterByValue(allCarsList, selectedTransmissionList, "transmission");
  //   const isFiltersNull = isAllFilterEmpty();
  //   if (isFiltersNull) {
  //     // if (hasSearchPageLoaded) {
  //     getAllCars();
  //     // }
  //     // setSearchPageNo(1);
  //   } else {
  //     setTransmissionFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [selectedTransmissionList]);

  // useEffect(() => {
  //   const newData = filterByValue(allCarsList, selectedColors, "color");
  //   const isFiltersNull = isAllFilterEmpty();
  //   if (isFiltersNull) {
  //     // fetch all cars again
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     setColorFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [selectedColors]);

  // useEffect(() => {
  //   const newData = filterByValue(allCarsList, selectedCategories, "body");
  //   const isFiltersNull = isAllFilterEmpty();
  //   if (isFiltersNull) {
  //     // fetch all cars again
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     // FILTERED DATA TEMP
  //     setCategoryFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [selectedCategories]);

  // useEffect(() => {
  //   const newData = filterByValue(allCarsList, selectedCarMakes, "make");
  //   const isFiltersNull = isAllFilterEmpty();
  //   if (isFiltersNull) {
  //     // fetch all cars again
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     setCarMakerFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [selectedCarMakes]);

  // useEffect(() => {
  //   const newData = filterByValue(allCarsList, selectedCarModels, "model");
  //   const isFiltersNull = isAllFilterEmpty();
  //   if (isFiltersNull) {
  //     // fetch all cars again
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     setCarModelFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [selectedCarModels]);

  // useEffect(() => {
  //   const newData = filterByRange(allCarsList, priceValues, "price", priceDiff, minPrice);

  //   const fullRange = priceValues[0] === 0 && kmsValues[1] === 100;
  //   const isFiltersNull = isAllFilterEmpty();
  //   if (isFiltersNull && fullRange) {
  //     // fetch all cars again
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     setPriceFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [priceValues]);

  // useEffect(() => {
  //   const newData = filterByRange(allCarsList, kmsValues, "odometer", kmsDiff, minKms);
  //   const isFiltersNull = isAllFilterEmpty();
  //   const fullRange = kmsValues[0] === 0 && kmsValues[1] === 100;
  //   if (isFiltersNull && fullRange) {
  //     // fetch all cars again
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     setKmsFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [kmsValues]);

  // useEffect(() => {
  //   const newData = filterByRange(allCarsList, yearValues, "manuyear", yearDiff, minYear);
  //   const isFiltersNull = isAllFilterEmpty();
  //   const fullRange = yearValues[0] === 0 && yearValues[1] === 100;
  //   if (isFiltersNull && fullRange) {
  //     // fetch all cars again
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     setYearFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [yearValues]);

  // useEffect(() => {
  //   const newData = filterByRange(allCarsList, noOwners, "owner", noOwnersDiff, minOwners);
  //   const isFiltersNull = isAllFilterEmpty();
  //   const fullRange = noOwners[0] === 0 && noOwners[1] === 100;
  //   if (isFiltersNull && fullRange) {
  //     getAllCars();
  //     // setSearchPageNo(1);
  //   } else {
  //     // FILTERED DATA TEMP
  //     setNoOwnersFilteredData(newData);
  //     // setSearchPageNo(1);
  //   }
  // }, [noOwners]);

  useEffect(() => {
    if (isFromCarByModal) {
      if (categoryFilteredData.length > 0) {
        setAllFilteredData(categoryFilteredData);
        setIsFromCarByModal(false);
      }
      if (carMakerFilteredData.length > 0) {
        setAllFilteredData(carMakerFilteredData);
        setIsFromCarByModal(false);
      }
    } else {
      // list is empty still it shold be sent to the the combining function.
      const arraysToCombine = [];
      if (yearValues[0] !== 0 || yearValues[1] !== 100) {
        arraysToCombine.push(yearFilteredData);
      }
      if (selectedTransmissionList.length > 0) {
        arraysToCombine.push(transmissionFilteredData);
      }
      if (selectedFuelList.length > 0) {
        arraysToCombine.push(fualFilteredData);
      }
      if (selectedColors.length > 0) {
        arraysToCombine.push(colorFilteredData);
      }
      if (selectedCategories.length > 0) {
        arraysToCombine.push(categoryFilteredData);
      }
      if (selectedCarMakes.length > 0) {
        arraysToCombine.push(carMakerFilteredData);
      }
      if (selectedCarModels.length > 0) {
        arraysToCombine.push(carModelFilteredData);
      }
      if (kmsValues[0] !== 0 || kmsValues[1] !== 100) {
        arraysToCombine.push(kmsFilteredData);
      }
      if (priceValues[0] !== 0 || priceValues[1] !== 100) {
        arraysToCombine.push(priceFilteredData);
      }
      if (noOwners[0] !== 0 || noOwners[1] !== 100) {
        arraysToCombine.push(noOwnersFilteredData);
      }

      const finalRenderData = getCombinedFilterData(...arraysToCombine);
      setAllFilteredData(finalRenderData);
    }
  }, [
    yearFilteredData,
    transmissionFilteredData,
    fualFilteredData,
    colorFilteredData,
    categoryFilteredData,
    carMakerFilteredData,
    carModelFilteredData,
    priceFilteredData,
    kmsFilteredData,
    noOwnersFilteredData,
    priceValues,
    kmsValues,
    noOwners,
    isFromCarByModal,
    selectedCarMakes,
    selectedCarModels,
    selectedCategories,
  ]);

  // Add this useEffect to sync the answers with keyInfo
  useEffect(() => {
    if (majorAccidentAnswer !== undefined && floodDamageAnswer !== undefined) {
      setKeyInfo(prev => ({
        ...prev,
        majorAccident: majorAccidentAnswer,
        floodDamage: floodDamageAnswer
      }));
    }
  }, [majorAccidentAnswer, floodDamageAnswer]);

  const updateVehicleInfo = (field, value) => {
    setVehiclesInfo(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const store = {
    totalCars: totalCars,
    setTotalCars: setTotalCars,
    userIp: userIp,
    setUserIp: setUserIp,
    allCarsList: allCarsList,
    setAllCarsList: setAllCarsList,
    searchPageNo: searchPageNo,
    setSearchPageNo: setSearchPageNo,
    itemsPerPage,
    currentPageCarList,
    allFilteredData,

    selectedYearList,
    setSelectedYearList,
    selectedTransmissionList,
    setSelectedTransmissionList,
    selectedFuelList,
    setSelectedFualList,
    selectedColors,
    setSelectedColors,
    selectedCategories,
    setSelectedCategories,
    selectedCarMakes,
    setSelectedCarMakes,
    selectedCarModels,
    setSelectedCarModels,
    priceValues,
    setPriceValues,
    kmsValues,
    setKmsValues,
    noOwners,
    setNoOwners,
    yearValues,
    setYearValues,

    setNonCategoryListEmpty,
    setNonMakeFilterEmpty,

    linkId,
    setLinkId,

    setIsFromCarByModal,

    setAllFilteredData,

    isAllFilterEmpty,

    setFiltersFromSession,

    setHasSearchPageLoaded,

    summaryData,
    updateSummaryData,
    inspectionSummary,
    updateInspectionSummary,
    lastSaved,
    challans,
    addChallan,
    removeChallan,
    setInitialChallans,
    calculateTotalChallans,
    loadInitialChallans,
    errorCodes,
    addErrorCode,
    keyInfo,
    setKeyInfo,
    updateKeyInfo,
    insuranceData,
    updateInsuranceData,
    dentsData,
    setDentsData,
    tyreLifeData,
    updateTyreLifeData,
    majorRepairs,
    setMajorRepairs,
    addRepair,
    removeRepair,
    minorRepairs,
    setMinorRepairs,
    ownerCount,
    setOwnerCount,
    categoryRatings,
    setCategoryRatings,
    categoryData,
    setCategoryData,
    inspectionData,
    setInspectionData,
    updateCategoryRating,
    reportViewData,
    setReportViewData,
    majorAccidentAnswer,
    floodDamageAnswer,
    averageTyreLife,
    hasTyreLifeData,
    parsedTyreLife,
    computedExteriorCondition,
    computedInteriorCondition,
    hasDentDetails,
    dentsAndScratchesMap,
    vehiclesInfo,
    setVehiclesInfo,
    updateVehicleInfo
  };

  return (
    <PortalContext.Provider value={store}>
      {props.children}
    </PortalContext.Provider>
  );
};

export default PortalContextProvider;
